import type { TFunction } from 'i18next'
import ProductListItem from './ProductListItem'

interface ProductListItemsProps {
  saleKeys: string[]
  activeTab: string
  onSelect: (key: string) => void
  formulaSlotRef: (node: HTMLDivElement | null) => void
  t: TFunction
}

const ProductListItems = ({ saleKeys, activeTab, onSelect, formulaSlotRef, t }: ProductListItemsProps) => (
  <>
    {saleKeys.map(key => (
      <ProductListItem
        key={key}
        saleKey={key}
        selected={activeTab === key}
        onSelect={onSelect}
        formulaSlotRef={formulaSlotRef}
        t={t}
      />
    ))}
  </>
)

export default ProductListItems
